import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Eventback from '../../../Component/Eventback'
import { Helmet } from "react-helmet";


export default function SmartStrategies() {


    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>Smart Strategies for Multi-Cloud Environments & Data Integration | Decimal Point Analytics</title>
                <meta name="description" content="Explore smart strategies for multi-cloud integration, data governance, and AI solutions with Decimal Point Analytics at Sofitel Mumbai" />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/roundtable-discussion-on-smart-strategies-for-multi-cloud-environments-and-data-integration" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>



            <Box id='event-details' className='section sec_bg' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={8} md={8} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Events
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Roundtable Discussion on Smart Strategies for Multi-Cloud Environments and Data Integration
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>


                    <Box className='whitebx'>

                        <Typography variant='h6' className='black jst'>
                            <strong>Smart Strategies for Multi-Cloud Environments and Data Integration</strong>
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Decimal Point Analytics participated in a roundtable discussion on Smart Strategies for Multi-Cloud Environments and Data Integration at Sofitel, Mumbai.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            <strong>Vaibhav Poonekar, Senior Vice President of Engineering</strong>, represented Decimal Point Analytics as a panelist, contributing to insightful discussions on:
                            <ul>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        <strong>Breaking down data silos</strong> and simplifying multi-cloud integration
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        <strong>Building secure, scalable data governance frameworks</strong>
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        <strong>Implementing adaptable AI solutions</strong> for growth and reliable analytics
                                    </Typography>
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant='h6' className='black jst' gutterBottom>
                            The session offered a valuable platform to exchange innovative ideas and explore actionable solutions for managing complex data environments.
                        </Typography>

                        <Typography variant='h6' className='black jst' gutterBottom>
                            We are excited to integrate these learnings into our services, ensuring our clients benefit from cutting-edge strategies in data analytics and AI.
                        </Typography>

                    </Box>

                    <Eventback />

                </Container>

            </Box>

        </>
    );
}
